module.exports = __webpack_public_path__ + "static/media/ViolinScore1-KELsMUSIC.305c3b40.jpg";